import React, { useState } from "react";
import "../../../css/ViewEditAppointmentModal.css"; // Your existing CSS for the view modal
import EditAppointmentDetailsModal from "./EditAppointmentDetailsModal";

// Interface for the data passed into the modal
interface Appointment {
  id: string; // centerId
  appointmentId: string; // appointmentClusterId
  centerName: string;
  centerType: string;
  city: string;
  startDate: string;
  endDate: string;
  slotDesigns: Record<string, string>;
  totalSlots: number;
  appointmentsPerSlot?: number;
}

interface ModalProps {
  appointment: Appointment;
  onClose: () => void;
  onAppointmentUpdated: () => void;
}

const ViewEditAppointmentModal: React.FC<ModalProps> = ({ appointment, onClose, onAppointmentUpdated }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const weekDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

  const handleEditClick = () => setIsEditModalOpen(true);
  const handleCloseEditModal = () => setIsEditModalOpen(false);

  const handleEditSaveSuccess = () => {
    handleCloseEditModal(); // Close the edit modal
    onClose(); // Close this view modal
    onAppointmentUpdated(); // Notify parent table to refresh
  };

  return (
    <>
      <div className="modal-backdrop" onClick={onClose}>
        <div className="modal-content view-edit-apt-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2 className="modal-title">View {appointment.centerType}</h2>
            <button className="global-close-btn" onClick={onClose}>✕</button>
          </div>
          <div className="modal-grid">
            <div><label>Center Name</label><p>{appointment.centerName}</p></div>
            <div><label>City</label><p>{appointment.city}</p></div>
          </div>
          <div className="modal-grid">
            <div><label>Start Date</label><p>{appointment.startDate}</p></div>
            <div><label>End Date</label><p>{appointment.endDate}</p></div>
          </div>
          <div className="slot-template-section">
            <label>Slot Template</label>
            <div className="slot-template-box">
              {appointment.centerType === "CAMP CENTER" ? (
                Object.keys(appointment.slotDesigns || {}).length > 0 ? (
                  Object.keys(appointment.slotDesigns).map(dateKey => (
                    <div key={dateKey} className="slot-template-row">
                      <span>{dateKey}</span>
                      <span>{appointment.slotDesigns[dateKey] || "Not specified"}</span>
                    </div>
                  ))
                ) : (
                  <div className="slot-template-row">
                    <span>No templates</span>
                  </div>
                )
              ) : (
                weekDays.map(day => (
                  <div key={day} className="slot-template-row">
                    <span>{day}</span>
                    <span>{appointment.slotDesigns?.[day] || "Not specified"}</span>
                  </div>
                ))
              )}
            </div>
          </div>
          <div className="appointments-per-slot">
            <label>Appointments per slot</label>
            <p>{appointment.appointmentsPerSlot}</p>
          </div>
          <div className="modal-actions-edit">
            <button className="edit-btn" onClick={handleEditClick}>Edit</button>
          </div>
        </div>
      </div>
      {isEditModalOpen && (
        <EditAppointmentDetailsModal
          appointment={appointment}
          onClose={handleCloseEditModal}
          onSaveSuccess={handleEditSaveSuccess}
        />
      )}
    </>
  );
};

export default ViewEditAppointmentModal;